import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'team-management/groups';

export const TOGGLE_GROUP_SELECTION = `${NAMESPACE}/TOGGLE_GROUP_SELECTION`;

const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const GROUP_LIST_GET = createApiNamespacedConstants('GROUP_LIST_GET');
export const AUTOCOMPLETE_GROUPS_GET = createApiNamespacedConstants('AUTOCOMPLETE_GROUPS_GET');
export const GROUP_CREATE = createApiNamespacedConstants('GROUP_CREATE');
export const GROUP_REMOVE = createApiNamespacedConstants('GROUP_REMOVE');
export const GET_ORGANIZATION_GROUPS_USAGE_CSV = createApiNamespacedConstants('GET_ORGANIZATION_GROUPS_USAGE_CSV');
